module.exports = __webpack_public_path__ + "bee456ffa8f60b0e4d5c5cd7aafbd084.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/order.png
// module id = 738
// module chunks = 0